/* eslint-disable react-hooks/exhaustive-deps */
import { useLazyQuery } from '@apollo/client'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import Footer from '../../../components/Footer'
import SharePillowModelViewer from '../../../components/GoogleModelViewer/SharePillowModelViewer'
import Header from '../../../components/Header'
import { beforeSelectedImageScaletom, currentPillowStateAtom, fabricAtom, loaderAtom, modelAtom, modelViewerSettingAtom, selectedImageScaletom, uploadImageAtom } from '../../../state'
import { GET_PRODUCT_SUMMARY } from '../graphQl/Query'
import AntdSpin from '../../../components/Loader/AntdSpin'
import { filterOrderStatus, ORDER_USER_STATUS } from '../../../components/constants/order-status'
import { progressStatus } from '../../../lib/utils/utils'
import ProgressBox from '../../../components/progress-box/progress-box'
import { CLOUD_FRONT_URL } from '../../../aws.config'

const SharePage = () => {
    // get id from url
    const { id } = useParams()
    // state define
    const [shareData, setShareData] = useState()
    const [selectedProduct, setSelectedProduct] = useState()
    const [selectedProductIndex, setSelectedProductIndex] = useState(0)
    const [, setCurrentPillowState] = useRecoilState(currentPillowStateAtom);
    const [, setFabricsAtomState] = useRecoilState(fabricAtom);
    const [modelAtomValue, setModelAtomValue] = useRecoilState(modelAtom);
    const [, setUploadImage] = useRecoilState(uploadImageAtom)
    const [loader, setLoader] = useRecoilState(loaderAtom)
    const [, setModelViewerSetting] = useRecoilState(modelViewerSettingAtom)
    const [, setInputValue] = useRecoilState(selectedImageScaletom);
    const [filterStatus, setFilterStatus] = useState(null)
    const [currentStatusIndex, setCurrentStatusIndex] = useState(null)
    const [, setInputSetValue] = useRecoilState(beforeSelectedImageScaletom);
    // Query 
    const [getSummary] = useLazyQuery(GET_PRODUCT_SUMMARY)
    const getCheckSupport = localStorage.getItem('checkSupport')

    function support_format_webp() {
        var elem = document.createElement('canvas');

        if (!!(elem.getContext && elem.getContext('2d'))) {
            // was able or not to get WebP representation
            return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
        }
        else {
            // very old browser like IE 8, canvas not supported
            return false;
        }
    }

    useEffect(() => {
        if (!getCheckSupport) {
            const checkSupport = support_format_webp()
            localStorage.setItem('checkSupport', JSON.stringify(checkSupport))
        }
    }, []);

    useEffect(() => {
        if (shareData) {
            let newOrderStatue = progressStatus(shareData?.productSummary, "")
            const newData = ORDER_USER_STATUS
            let currentStatusIndex = newData.findIndex((o) => o.status === newOrderStatue) ?? 0;
            const filterStatus = filterOrderStatus(newData, currentStatusIndex);
            const userData = ['pending', 'paidOrder', 'sentToWorkroom', 'readyForPickup']
            if (!userData?.includes(newOrderStatue)) {
                if (['vendorOrder', 'shipped', 'received']?.includes(newOrderStatue)) {
                    newOrderStatue = "paidOrder"
                    currentStatusIndex = 1
                } else {
                    newOrderStatue = "readyForPickup"
                    currentStatusIndex = 3
                }
            }

            setCurrentStatusIndex(currentStatusIndex)
            setFilterStatus(filterStatus)
        }
    }, [shareData])

    // when id is change call getPoductSummary query
    useEffect(() => {
        if (id) {
            setLoader(true)
            const summaryFun = async () => {
                const { data } = await getSummary({
                    variables: {
                        uniqueCode: id
                    }
                })
                const selectedRecord = data?.getProductSummaryByUniCode?.productSummary?.[0]
                setShareData(data?.getProductSummaryByUniCode)
                selectProductCustomize(selectedRecord)
                setLoader(false)
            }
            summaryFun()
        }
    }, [id])

    const selectProductCustomize = (data) => {
        setSelectedProduct(data)
        const { modelAtomValue, fabric, name, inputValue, uploadImage, inputSetValue, modelViewerSetting } = data;
        setModelViewerSetting(modelViewerSetting)
        setInputSetValue(inputSetValue)
        setInputValue(inputValue)
        setUploadImage(uploadImage)
        setModelAtomValue(modelAtomValue)
        setFabricsAtomState(fabric)
        setCurrentPillowState(name)
    }

    const pillowRender = () => {
        // const sizePart = selectedProduct?.parts.find(item => item.type === 'size')

        return (
            <div className='w-100'>
                <p> {selectedProduct?.seriesName} {selectedProduct?.name}</p>
                <div className='border-gray'></div>

                <div>
                    <p className='color-gray my-2' >Qty: {selectedProduct?.quantity}</p>
                    {selectedProduct?.result && Object.entries(selectedProduct.result).map(([key, value]) => (
                        <p key={key} className='color-gray my-2' >{key}: {value}</p>
                    ))}
                </div>
            </div>
        )
    }

    return (
        <>
            <Header isIcons={false} isSearchBar={false} />
            <div className='border-gray mb-3'></div>
            {loader && !shareData?.productSummary && <AntdSpin />}
            <div className='m-10'>
                <ProgressBox
                    data={filterStatus}
                    status={progressStatus(shareData?.productSummary, "")}
                    filledIndex={currentStatusIndex}
                />
            </div>
            <div className="container-fluid summary-header-card pt-4 pb-5">
                <div>
                    <h5 className="title text-center">PROJECT SUMMARY</h5>
                    <h6 className="sub-title mt-4 text-center">{shareData?.name}</h6>
                    <p className="sub-title text-center color-gray">{shareData?.email}</p>
                    <div className='row justify-content-center'>
                        {shareData?.productSummary?.map((data, index) => {
                            const selected = selectedProductIndex === index
                            return (
                                <div
                                    key={`${data?.name} ${index}`}
                                    className={`card !w-[14rem] mt-4 cursor-pointer p-0 me-md-4 mb-lg-0 mb-4 align-items-center ${selected ? 'active-category' : 'border-gray'}`}
                                    onClick={() => {
                                        setSelectedProductIndex(index)
                                        selectProductCustomize(data)
                                        setLoader(true)
                                    }}>
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <img className="card-img-top" src={`${CLOUD_FRONT_URL}${data?.base64Image}`} alt="Card image cap" />
                                    </div>
                                    <div className="card-body text-center border-top-gray w-100" >
                                        <p className={`${selected ? 'text-black' : 'color-gray'} card-text  `}>
                                            {data?.seriesName} {data?.name}
                                        </p>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
            <div className="product-info-row container">
                <div className="row ">
                    <div className="col-lg-6 col-xl-6 left-part mt-rem-6 mt-0 d-flex justify-content-between flex-column h-[57vh]">
                        {selectedProduct?.type === 'pillow' && modelAtomValue?.src ? <SharePillowModelViewer /> : <></>}
                    </div>
                    <div className="col-lg-6 col-xl-6 right-part text-left mobile-shadow mt-4">
                        <div className="d-flex align-items-stretch tab-item-wrapper mt-3">
                            {selectedProduct?.type === 'pillow' ? pillowRender() : ''}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default SharePage